import React, { Component } from "react";
import Store from "../../content/Store";
import Content from "../../content/Content";
import { Redirect } from "react-router-dom";
import { connect } from "react-redux";
import styles from "../../assets/css/modules/myprofile/myprofilecommunicationprefs.css";
import HelpSection from "../shared/HelpSection";
import CommPreferenceSection from "../shared/CommPreferenceSection";
// import PromoImageCard from "../../components/shared/PromoImageCard";
import PreferenceRequired from '../shared/PreferenceRequired';
import MemberHelper from "../../helpers/MemberHelper";
import {
  saveCommunicationPreferences,
  loadOptionValues,
  setIsCommValueChanged
} from "../../actions/policy/policyActions";
import { PolicyType } from "../../constants/Constants";
import TabNavWithHeader from "../../components/shared/navigation/TabNavWithHeader";
import { Paths } from "../../constants/UrlConstants";
import ShadowedContainer from "../shared/containers/ShadowedContainer";
import CommPreferenceButton from "../shared/buttons/CommPreferenceButton";
import MskSection from "../shared/MskSection";
import DateHelper from "../../helpers/DateHelper";
import { getLayout } from "../../layout/Layout";
import { Layouts } from "../../constants/Constants";
import PromoImageCard from "../../components/shared/PromoImageCard";

const getPrintPreferenceCopy = (printPreferencePolicyType) => {
  if (printPreferencePolicyType === PolicyType.SME) {
    return Store.MyProfileCommunicationNeeds.PrintPreferenceCopyForSME;
  }
  return Store.MyProfileCommunicationNeeds.PrintPreferenceCopyForIndividual;
};

const getPrintPreferencePolicyType = (selectedPolicy) => {
  let smePolicyType = false;

  if (selectedPolicy && selectedPolicy.IsFormat2) {
    if (!(selectedPolicy.IsHealthSelect && selectedPolicy.IsIndividual)) {
      smePolicyType = true;
    }
  } else {
    if (selectedPolicy && selectedPolicy.IsSME) {
      smePolicyType = true;
    }
  }

  if (smePolicyType) {
    return PolicyType.SME;
  }

  return PolicyType.Individual;
};

export const mapStateToProps = ({ policyReducer = {}, preferenceReducer = {} }) => {
  const selectedPolicy = policyReducer.selectedPolicy;
  const currentMember = MemberHelper.getCurrentLoggedInMemberFromPolicy(
    selectedPolicy
  );
  const policyType = getPrintPreferencePolicyType(selectedPolicy);
  const isAgeAbove18 = DateHelper.isAgeAbove18(currentMember.DateOfBirth);

  return {
    MembershipNumber: selectedPolicy && selectedPolicy.MembershipNumber,
    Members: selectedPolicy && selectedPolicy.Members,
    IsInternational: selectedPolicy && selectedPolicy.IsInternational,
    IsSaga: selectedPolicy && selectedPolicy.IsSaga,
    IsHealthSelect: selectedPolicy && selectedPolicy.IsHealthSelect,
    DocumentPreference: currentMember.DocumentPreference,
    PrintPreferenceContent: getPrintPreferenceCopy(policyType),
    PolicyType: policyType,
    IsLapsed: selectedPolicy && selectedPolicy.IsLapsed,
    PersonConsent: selectedPolicy && selectedPolicy.PersonConsent,
    TelephonePolicyServicing:
      selectedPolicy &&
      selectedPolicy.PolicyServicingTelephones &&
      selectedPolicy.PolicyServicingTelephones.TelephonePolicyServicing,
    disabled:
      policyReducer.policyDetails && policyReducer.policyDetails.IsInternalView,
    communicationPreferenceKeys: preferenceReducer.communicationPreferencekeys,
    communicationValue : preferenceReducer.communicationValue,
    saveCommunicationPref:preferenceReducer.saveCommunicationPref,
    isElgibleCustomised: preferenceReducer.isElgibleCustomised,
    personnotfound: preferenceReducer.personnotfound,
    isAgeAbove18
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    saveCommunicationPreferences:(membershipNumber,updateCommunicationPreferences)=>
      dispatch(saveCommunicationPreferences(membershipNumber,updateCommunicationPreferences)),
    loadOptionValues: (MembershipNumber) => dispatch(loadOptionValues(MembershipNumber)),
    setIsCommValueChanged:(Value) => dispatch(setIsCommValueChanged(Value)),
  };
};

export class MyProfileCommunicationNeeds extends Component {
  constructor(props) {
    super(props);
    this.state = {
      PersonConsent: props.PersonConsent,
      shownErrors: null,
      preferenceErrors: false,
      preferenceUpdateSuccess: false,
      contactPreferenceUpdateSucceeded: false,
      localDocumentPreference: props.DocumentPreference,
      updateCommunicationPreferences: null,
      shownCommErrors: false,
      commPrefsUpdateSucceeded: false,
      MemberName:null,
      noSelectionError:false,
      IsOnChange:false,
      noChangesError:false,
    };
    this.onCommunicationPreferenceSubmit = this.onCommunicationPreferenceSubmit.bind(this);
  }

  componentDidMount(){
    if(this.props.Members !== null && this.props.Members !== undefined){
      let loggedInMember=this.props.Members.find((val)=>val.IsLoggedInMember===true);
      if(loggedInMember !== null && loggedInMember !== undefined)
      {
        this.setState({ MemberName:loggedInMember.FullName});
      }
    }
  }

  onCommunicationPreferenceSubmit(e){
    e.preventDefault();
    this.props.setIsCommValueChanged(false);
    if(this.state.updateCommunicationPreferences !== null && 
      this.state.updateCommunicationPreferences.length !== 0)
    {
      this.setState({
        shownCommErrors: false,
        noSelectionError:false,
        commPrefsUpdateSucceeded: false,
        IsOnChange:false,
        noChangesError:false,
      });
      let IsDeletedTrue = [];
      if(this.state.updateCommunicationPreferences.length !== 0)
      {
        IsDeletedTrue = this.state.updateCommunicationPreferences.filter((val)=>{
            return val.IsDeleted === true;
        });
      }
    
      this.props
        .saveCommunicationPreferences(
          this.props.MembershipNumber,
          this.state.updateCommunicationPreferences,
        )
        .then(() => {
        if(this.props.saveCommunicationPref !==null && 
          this.props.saveCommunicationPref !== undefined && 
          this.props.saveCommunicationPref !== false)
        {
          this.props.loadOptionValues(this.props.MembershipNumber);
          if(this.state.updateCommunicationPreferences.length > 0 &&
            this.state.updateCommunicationPreferences.length === IsDeletedTrue.length &&
            this.props.communicationValue.length === this.state.updateCommunicationPreferences.length
            )
            {
              this.setState({
                noSelectionError:true,
                shownCommErrors: false,
                commPrefsUpdateSucceeded: false,
                IsOnChange:false,
                noChangesError:false,
              });
            }
            else{
              this.setState({
                shownCommErrors: false,
                noSelectionError:false,
                commPrefsUpdateSucceeded: true,
                IsOnChange:false,
                noChangesError:false,
              });
            }
      }
        else{
          this.setState({
            shownCommErrors: true,
            noSelectionError:false,
            commPrefsUpdateSucceeded: false,
            IsOnChange:false,
            noChangesError:false,
          });
        }
      });
    }
  }

  render() {
    return this.props.IsLapsed && !this.props.PersonConsent ? (
      <Redirect to={Paths.NotFound} />
    ) : (
      <div className={styles.myprofilecommunicationprefs}>
        <TabNavWithHeader
          heading={Store.MyProfileHeader.Heading}
          backgroundColourClass={getLayout()===Layouts.HOL ? styles.backgroundColourClassHOL :styles.backgroundColourClass}
          links={
            this.props.IsInternational || this.props.IsSaga
              ? Store.MyProfileHeader.LinksWithoutPermissions
              : Store.MyProfileHeader.Links
          }
          currentLinkIndex={1}
        />
        <TabNavWithHeader
          applyTabNavWithImageStyles={true}
          links={ (this.props.isElgibleCustomised === "true" && this.props.personnotfound !== true) ||
          this.props.isElgibleCustomised === null
                  ?Store.CustomisedPreference.Links
                  :Store.CustomisedPreference.LinksWithoutCommunicationNeed}
          currentLinkIndex={1}
        />
        <ShadowedContainer>
        <div className={styles.pageContainer}>
        <PreferenceRequired isPreferenceRequired
        keys={this.props.communicationPreferenceKeys}
        values={this.props.communicationValue}>
        {this.props.isElgibleCustomised === "true" && this.props.personnotfound !== true? 
        this.props.communicationPreferenceKeys !== null && 
        this.props.communicationValue !== undefined ?(<div className="row">
              <div id="communicationPreferenceSection" className="col-12">
                <h2><Content
                      name={Store.MyProfileCommunicationNeeds.CommSection.Heading}
                    /></h2>
                <Content
                      name={Store.MyProfileCommunicationNeeds.CommSection.Subheading}
                    />
                <CommPreferenceSection 
                    commPrefsKeys={this.props.communicationPreferenceKeys}
                    communicationValue={this.props.communicationValue}
                    MemberName={this.state.MemberName}
                    IsCommValueChanged={(value)=>
                      this.setState({
                        IsOnChange:value
                      })}
                    updateCommPreferences={(commprefs) =>
                      this.setState({
                        updateCommunicationPreferences: commprefs,
                        shownCommErrors: null,
                        commPrefsUpdateSucceeded: false,
                        noSelectionError:false
                      })
                    }
                    Zebrafied={true}
                    UseSlider={false}
                    Subheading = {Store.MyProfileCommunicationNeeds.CommSectionSubheading}
                    isMyProfileCommPref = {true}>
                </CommPreferenceSection>
                <div id="personconsentMessage">
                      {this.state.shownCommErrors ? (
                        <div
                          className={
                            "alert alert-danger mt-2 " + styles.messages
                          }
                          role="alert"
                        >
                          <Content name={Store.MyProfileCommunicationNeeds.SaveCommPreferenceError} />
                        </div>
                      ) : null}
                      {this.state.noSelectionError ? (
                        <div
                          className={
                            "alert alert-success mt-2 " + styles.messages
                          }
                          role="alert"
                        >
                          <Content name={Store.MyProfileCommunicationNeeds.noSelectionCommPreferenceError} />
                        </div>
                      ) : null}
                      {this.state.commPrefsUpdateSucceeded ? (
                        <div
                          className={
                            "alert alert-success mt-2 " + styles.messages
                          }
                          role="alert"
                        >
                          <Content
                            name={
                              Store.MyProfileCommunicationNeeds
                                .SaveCommPreferenceSuccess
                            }
                          />
                        </div>
                      ) : null}
                      {this.state.noChangesError ?(
                          <div
                          className={
                            "alert alert-danger mt-2 " + styles.messages
                          }
                          role="alert"
                        >
                          <Content
                            name={
                              Store.MyProfileContactPreferences
                                .NoChangesMessage
                            }
                          />
                        </div>
                      ):null}
                    </div>
                <form onSubmit={this.onCommunicationPreferenceSubmit}>
                    <div className={"row " + styles.commSection}>
                      <div className="col-sm-12 text-right">
                        <CommPreferenceButton
                          id="btn-contactPreference"
                          type="submit"
                          className="form-control btn btn-submit"
                          disabled={this.props.disabled}
                          label={
                            Store.MyProfileContactPreferences.UpdateButton
                          }
                        />
                      </div>
                    </div>
                  </form>
              </div>
            </div>):(
              <div
              className={
                "alert alert-danger mt-2 " + styles.messages
              }
              role="alert"
            >
              <Content
                name={
                  Store.MyProfileCommunicationNeeds.Errors.GetMasterDataFailed
                }
              />
            </div>
            ):null}
          </PreferenceRequired>
            <div className="row">
              <div className="col-12">
                <div className={styles.helpSection}>
                  <HelpSection
                    HeadingLinkText={
                      Store.MyProfileCommunicationNeeds.HelpSection
                        .HeadingLinkText
                    }
                    HeadingLinkTo={
                      Store.MyProfileCommunicationNeeds.HelpSection
                        .HeadingLinkTo
                    }
                    MoreHelpLinkText={
                      Store.MyProfileCommunicationNeeds.HelpSection
                        .MoreHelpLinkText
                    }
                    MoreHelpLinkTo={
                      Store.MyProfileCommunicationNeeds.HelpSection
                        .MoreHelpLinkTo
                    }
                    HelpSet={Store.MyProfileCommunicationNeeds.HelpSection.Faq}
                  />
                </div>
              </div>
            </div>
          </div>
        </ShadowedContainer>
        <div className={"home " + styles.healthStore}>
          <div className="container">
            <div className="row">
              <div className="col-sm-12">
                {!this.props.IsLapsed && (this.props.isAgeAbove18 ? <MskSection UniqueKey="mskBanner"  accessPage={Paths.CommunicationPreference} />:
                (<PromoImageCard
                  ImgSrc={Store.PromoCards.AccessHealthSupportSrc.IconSrc}
                  ImgSrcMobile={
                    Store.PromoCards.AccessHealthSupportSrc.IconSrcMobile
                  }
                  Heading={Store.PromoCards.AccessHealthSupportSrc.Heading}
                  Description={
                    Store.PromoCards.AccessHealthSupportSrc.Description
                  }
                  LinkText={Store.PromoCards.AccessHealthSupportSrc.LinkText}
                  LinkTo={getLayout()===Layouts.HOL ?  Store.PromoCards.AccessHealthSupportSrc.LinkToHOL : Store.PromoCards.AccessHealthSupportSrc.LinkTo}
                  LeftImage
                />
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(MyProfileCommunicationNeeds);
